import styled from 'styled-components';

const ContentWrapper = styled.div`
  align-items: center;
  background-color: var(--color-accent-primary-weakest);
  color: var(--color-accent-secondary-default);
  display: flex;
  flex: 1;
  padding: 24px;
  width: 100%;
`;

const Col = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  gap: 8px;
`;

export { Col, ContentWrapper };
